import { getUserConfiguration } from 'owa-session-store';

export function getUserWeekStartDay(): number {
    return getUserConfiguration()?.UserOptions?.WeekStartDay ?? 0;
}
